// Filter and Sort components for DealerDashboard tables
import React from 'react';
import { Select, Button, Dropdown, Menu } from 'antd';
import { FilterOutlined, SortAscendingOutlined, SortDescendingOutlined, DownOutlined } from '@ant-design/icons';

// Filter dropdown component
export const renderFilterDropdown = (columnKey, options, isLeftSwipes = true, currentFilters, handleColumnFilter) => {
  const currentValues = currentFilters[columnKey] || [];
  
  return (
    <Select
      mode="multiple"
      placeholder="Filter"
      value={currentValues}
      onChange={(values) => handleColumnFilter(columnKey, values, isLeftSwipes)}
      style={{ 
        minWidth: '120px',
        maxWidth: '200px'
      }}
      size="small"
      showSearch
      filterOption={(input, option) =>
        option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      allowClear
      maxTagCount="responsive"
      dropdownStyle={{ maxHeight: '300px' }}
      suffixIcon={<FilterOutlined style={{ color: currentValues.length > 0 ? '#1890ff' : '#8c8c8c' }} />}
    >
      {options.map(option => (
        <Select.Option key={option.value} value={option.value}>
          {option.label}
        </Select.Option>
      ))}
    </Select>
  );
};

// Sort dropdown component
export const renderSortDropdown = (columnKey, isLeftSwipes = true, currentSort, handleColumnSort) => {
  const currentOrder = currentSort[columnKey];
  
  const menu = (
    <Menu
      selectedKeys={currentOrder ? [currentOrder] : []}
      onClick={({ key }) => {
        if (key === 'clear') {
          handleColumnSort(columnKey, null, isLeftSwipes);
        } else if (key === 'asc' || key === 'desc') {
          handleColumnSort(columnKey, key, isLeftSwipes);
        }
      }}
    >
      <Menu.Item key="asc">
        <SortAscendingOutlined /> Low to High
      </Menu.Item>
      <Menu.Item key="desc">
        <SortDescendingOutlined /> High to Low
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="clear">
        Clear Sort
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['click']} placement="bottomLeft">
      <Button 
        type="text" 
        size="small" 
        icon={currentOrder === 'asc' ? <SortAscendingOutlined /> : 
              currentOrder === 'desc' ? <SortDescendingOutlined /> : <DownOutlined />}
        style={{ 
          color: currentOrder ? '#1890ff' : '#8c8c8c',
          padding: '4px 8px'
        }}
      />
    </Dropdown>
  );
};
